import { useQuery } from "@tanstack/react-query";
import { CommonAgentSummary, CommonAPI } from "../../types";
import { Card, CardGrid, Histogram, useAATheme } from "@bagel-web/components";
import { Spinner } from "react-bootstrap";
import { useMemo } from "react";
import { useRouter } from "next/router";
import { getSessionHistogramDataByAgent } from "./dataTransformations";

const SessionHistogram = ({
  sessionId,
  agents,
  commonAPI,
}: {
  sessionId: string;
  agents: Array<CommonAgentSummary>;
  commonAPI: CommonAPI;
}) => {
  const { data: sessionStats, isPending } = useQuery({
    queryKey: ["session-histogram", sessionId],
    queryFn: () => commonAPI.fetchSessionStats({ sessionId, numBuckets: 50 }),
  });

  const { isDarkMode } = useAATheme();
  const structuredSessionStats = useMemo(() => {
    return getSessionHistogramDataByAgent({ agents, sessionStats, isDarkMode });
  }, [sessionStats, agents, isDarkMode]);

  const router = useRouter();

  const handleClickElement = (dataSetIndex: number, index: number) => {
    const agentId =
      structuredSessionStats?.datasets?.[dataSetIndex]?.data[index]?.agentId;
    const moment =
      structuredSessionStats?.datasets?.[dataSetIndex]?.data[index]?.start
        .moment;
    if (agentId && moment) {
      router.push(`/sessions/${sessionId}/agent/${agentId}?momentId=${moment}`);
    }
  };

  return (
    <CardGrid className="mt-3" maxColumns={1}>
      <Card title="Activity by Agent">
        {isPending && <Spinner />}
        {!isPending && (
          <Histogram
            id="session-histogram"
            data={structuredSessionStats}
            onClickElement={handleClickElement}
          />
        )}
      </Card>
    </CardGrid>
  );
};

export default SessionHistogram;
